import React from "react";
import type { NotificationContainerChildProps } from "./VendorNotificationContainer";
import { Button, NotificationListBase } from "@semo/shared-ui";

interface NotificationDropdownViewProps extends NotificationContainerChildProps {
  /**
   * 알림 센터(설정) 화면으로 가는 버튼. 그 화면이 아직 없으면 넘기지 않는다 — 누르면 «준비 중»
   * 이 뜨는 버튼을 두지 않기 위해서다(V-15).
   */
  onNavigateToSettings?: () => void;
}

/**
 * NotificationDropdownView - Presentation Component
 *
 * Pure UI component for dropdown display.
 * All business logic is handled by NotificationContainer.
 */
export const NotificationDropdownView: React.FC<
  NotificationDropdownViewProps
> = ({
  notifications,
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
  markAllAsRead,
  onItemClick,
  isMarkingAsRead,
  hasUnread,
  onNavigateToSettings,
}) => {
  return (
    <>
      {/* Header */}
      <div className="p-3 sm:p-4 border-b border-slate-100  flex items-center justify-between bg-white  rounded-t-md">
        <span className="font-semibold text-sm sm:text-base text-slate-900 ">
          알림
        </span>
        {hasUnread && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => markAllAsRead()}
            disabled={isMarkingAsRead}
            className="text-xs text-slate-500 hover:text-slate-900 h-auto p-1"
            aria-label="모두 읽음"
          >
            모두 읽음
          </Button>
        )}
      </div>

      {/* Notification List */}
      <div className="p-1.5 sm:p-2 bg-slate-50/50 ">
        <NotificationListBase
          compact
          notifications={notifications.map((n) => ({
            id: n.notificationId,
            type: n.type,
            title: n.title,
            content: n.content,
            time: n.time,
            isRead: n.isRead,
            icon: n.icon,
            color: n.color,
            resourceType: n.resourceType,
            resourceId: n.resourceId,
          }))}
          isLoading={isLoading}
          enableInfiniteScroll={true}
          isFetchingMore={isFetchingNextPage}
          hasMore={hasNextPage}
          onLoadMore={fetchNextPage}
          onItemClick={onItemClick}
        />
      </div>

      {/* Footer */}
      {onNavigateToSettings && (
        <div className="p-2.5 sm:p-3 border-t border-slate-100  text-center bg-white  rounded-b-md">
          <Button
            variant="ghost"
            size="sm"
            className="text-xs font-semibold text-slate-500 hover:text-primary-text w-full py-1 h-auto"
            onClick={onNavigateToSettings}
          >
            알림 센터로 이동
          </Button>
        </div>
      )}
    </>
  );
};
